import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {ImageVM} from "../../models/ImageVM.model";
import {CompanyVM} from "../../models/CompanyVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {CategoryVM} from "../../models/CategoryVM.model";
import {CategoryService} from "../../services/category/category.service";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";


@Component({

  selector: 'rw-service-list',  // <home></home>

  styles: [require('./service-list.component.css')],

  template: require('./service-list.component.html')
})
export class ServiceListComponent implements OnInit, OnChanges {
  @Input() public company: CompanyVM;
  @Input() public canReserveByClient: boolean;
  public categories: CategoryVM[] = [];
  public mainCat: CategoryVM;


  /**
   * TypeScript public modifiers
   */
  constructor(private activatedRoute: ActivatedRoute, private companyService: CompanyService, private categoryService: CategoryService) {
  }

  public imageList: ImageVM[];

  public ngOnInit() {
    this.getCompanyCategory();
  }

  getCompanyCategory() {

    let parent = this;
    this.companyService.getCompanyInfo().subscribe((com) => {
      parent.company = com;
      parent.categoryService.getRootCategories(parent.company.keyUrl).subscribe(cats => {
        parent.categories = cats;

        // let i = 0;
        // let defCat = [];
        // cats.forEach(element => {
        //   if (element.categoryName === 'DEFAULT_CATEGORY'){
        //     defCat = [...defCat, cats[i]];
        //     cats.splice(i,1);
        //     parent.mainCat = cats[i];
        //     i += 1;
        //   }
        // })

        if (cats.length == 1)
          parent.mainCat = cats[0];
        parent.getCategoriesChilds(parent.mainCat);
        parent.getCategoryServices(parent.mainCat);
        //parent.categories.forEach((c)=> {
        //  parent.categoryService.getServiceItemsByCategoryId(c.id)
        //    .subscribe((services)=> {
        //       c.serviceList=services;
        //    });
        //});

      });
    });

  }

  onCategoryExpanded(cat) {
    this.getCategoryServices(cat);
    this.getCategoriesChilds(cat);
    cat.hideToggle = true;
  }

  onCategoryCollapsed(cat) {
    cat.hideToggle = false;
  }

  onServiceExpanded(si) {
    let parent = this;
    if (si && !si.detail) {
      parent.categoryService.getServiceItemDetailById(si.id)
        .subscribe((sdetail) => {
          si.detail = sdetail;
          parent.setDuration(si.detail);
          this.getServiceImage(si.detail);
        })
    }
  }

  getCategoryServices(cat: CategoryVM) {
    let parent = this;
    if (cat && !cat.serviceList)
      parent.categoryService.getServiceItemsHeaderByCategoryId(cat.id)
        .subscribe((services) => {
          cat.serviceList = services;
        });
  }

  getCategoriesChilds(cat: CategoryVM) {
    let parent = this;
    if (cat && !cat.serviceList)
      parent.categoryService.getCategoriesByParentId(cat.id)
        .subscribe((cats) => {
          cat.categories = cats;

        });
  }

  ngOnChanges(changes: SimpleChanges): void {

    let parent = this;


  }

  getServiceImage(si: ServiceItemDetailVM) {
    let parent = this;
    if (si && si.imageAlbum && si.imageAlbum.imageList && si.imageAlbum.imageList.length > 0) {

      si.coverImage = si.imageAlbum.imageList[0];
    }
  }

  setDuration(sd) {
    if (sd.scheduleInfo && sd.scheduleInfo.weeklyScheduleInfo && sd.scheduleInfo.weeklyScheduleInfo.timePeriod) {
      sd.duration = sd.scheduleInfo.weeklyScheduleInfo.timePeriod.duration;
    }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/service-list/service-list.component.ts